import Vuex from 'vuex';
import iStoreSession from '@/framework/connection/stores/storeSession';
import iStoreAccidentTravail from '@/generated/stores/modules/storeAccidentTravail';
import iStoreActivite from '@/generated/stores/modules/storeActivite';
import iStoreActualite from '@/generated/stores/modules/storeActualite';
import iStoreApprenti from '@/generated/stores/modules/storeApprenti';
import iStoreAttestation from '@/generated/stores/modules/storeAttestation';
import iStoreAttestationDef from '@/generated/stores/modules/storeAttestationDef';
import iStoreAuthorizedCredit from '@/generated/stores/modules/storeAuthorizedCredit';
import iStoreContrat from '@/generated/stores/modules/storeContrat';
import iStoreContratTemplate from '@/generated/stores/modules/storeContratTemplate';
import iStoreCreneau from '@/generated/stores/modules/storeCreneau';
import iStoreEtablissement from '@/generated/stores/modules/storeEtablissement';
import iStoreFractionDsn from '@/generated/stores/modules/storeFractionDsn';
import iStoreLieu from '@/generated/stores/modules/storeLieu';
import iStoreManualBillingDocument from '@/generated/stores/modules/storeManualBillingDocument';
import iStoreNumeroObjet from '@/generated/stores/modules/storeNumeroObjet';
import iStoreObjetMetier from '@/generated/stores/modules/storeObjetMetier';
import iStorePaie from '@/generated/stores/modules/storePaie';
import iStorePlageCreneau from '@/generated/stores/modules/storePlageCreneau';
import iStoreProjet from '@/generated/stores/modules/storeProjet';
import iStoreRubrique from '@/generated/stores/modules/storeRubrique';
import iStoreSalarie from '@/generated/stores/modules/storeSalarie';
import iStoreSupport from '@/generated/stores/modules/storeSupport';
import iStoreAdresse from '@/generated/stores/modules/storeAdresse';
import iStoreCivilite from '@/generated/stores/modules/storeCivilite';
import iStoreClient from '@/generated/stores/modules/storeClient';
import iStoreContact from '@/generated/stores/modules/storeContact';
import iStoreMail from '@/generated/stores/modules/storeMail';
import iStoreNumero from '@/generated/stores/modules/storeNumero';
import iStoreQualite from '@/generated/stores/modules/storeQualite';
import iStoreUser from '@/generated/stores/modules/storeUser';
import iStoreNotif from '@/generated/stores/modules/storeNotif';
import iStoreChat from '@/generated/stores/modules/storeChat';
import iStoreDocument from '@/generated/stores/modules/storeDocument';
import iStoreDocumentType from '@/generated/stores/modules/storeDocumentType';
import iStoreBill from '@/generated/stores/modules/storeBill';
import iStoreDelivery from '@/generated/stores/modules/storeDelivery';
import iStoreTransaction from '@/generated/stores/modules/storeTransaction';
import iStorePaymentMeans from '@/generated/stores/modules/storePaymentMeans';
import iStoreRib from '@/generated/stores/modules/storeRib';
import iStoreBank from '@/generated/stores/modules/storeBank';
import iStoreAccountEntry from '@/generated/stores/modules/storeAccountEntry';
import iStoreWizardItem from '@/generated/stores/modules/storeWizardItem';
import iStoreSubscription from '@/generated/stores/modules/storeSubscription';
import iStoreSubscriptionType from '@/generated/stores/modules/storeSubscriptionType';
import iStoreMetaAttrib from '@/generated/stores/modules/storeMetaAttrib';
import { getModule } from 'vuex-module-decorators';

const store = new Vuex.Store({
  modules: {
    iStoreSession,
    iStoreAccidentTravail,
    iStoreActivite,
    iStoreActualite,
    iStoreApprenti,
    iStoreAttestation,
    iStoreAttestationDef,
    iStoreAuthorizedCredit,
    iStoreContrat,
    iStoreContratTemplate,
    iStoreCreneau,
    iStoreEtablissement,
    iStoreFractionDsn,
    iStoreLieu,
    iStoreManualBillingDocument,
    iStoreNumeroObjet,
    iStoreObjetMetier,
    iStorePaie,
    iStorePlageCreneau,
    iStoreProjet,
    iStoreRubrique,
    iStoreSalarie,
    iStoreSupport,
    iStoreAdresse,
    iStoreCivilite,
    iStoreClient,
    iStoreContact,
    iStoreMail,
    iStoreNumero,
    iStoreQualite,
    iStoreUser,
    iStoreNotif,
    iStoreChat,
    iStoreDocument,
    iStoreDocumentType,
    iStoreBill,
    iStoreDelivery,
    iStoreTransaction,
    iStorePaymentMeans,
    iStoreRib,
    iStoreBank,
    iStoreAccountEntry,
    iStoreWizardItem,
    iStoreSubscription,
    iStoreSubscriptionType,
    iStoreMetaAttrib,
  },
  state: {},
  mutations: {},
  actions: {
    clearData () {
      storeAccidentTravail.mAccidentTravailClearData();
      storeActivite.mActiviteClearData();
      storeActualite.mActualiteClearData();
      storeApprenti.mApprentiClearData();
      storeAttestation.mAttestationClearData();
      storeAttestationDef.mAttestationDefClearData();
      storeAuthorizedCredit.mAuthorizedCreditClearData();
      storeContrat.mContratClearData();
      storeContratTemplate.mContratTemplateClearData();
      storeCreneau.mCreneauClearData();
      storeEtablissement.mEtablissementClearData();
      storeFractionDsn.mFractionDsnClearData();
      storeLieu.mLieuClearData();
      storeManualBillingDocument.mManualBillingDocumentClearData();
      storeNumeroObjet.mNumeroObjetClearData();
      storeObjetMetier.mObjetMetierClearData();
      storePaie.mPaieClearData();
      storePlageCreneau.mPlageCreneauClearData();
      storeProjet.mProjetClearData();
      storeRubrique.mRubriqueClearData();
      storeSalarie.mSalarieClearData();
      storeSupport.mSupportClearData();
      storeAdresse.mAdresseClearData();
      storeCivilite.mCiviliteClearData();
      storeClient.mClientClearData();
      storeContact.mContactClearData();
      storeMail.mMailClearData();
      storeNumero.mNumeroClearData();
      storeQualite.mQualiteClearData();
      storeUser.mUserClearData();
      storeNotif.mNotifClearData();
      storeChat.mChatClearData();
      storeDocument.mDocumentClearData();
      storeDocumentType.mDocumentTypeClearData();
      storeBill.mBillClearData();
      storeDelivery.mDeliveryClearData();
      storeTransaction.mTransactionClearData();
      storePaymentMeans.mPaymentMeansClearData();
      storeRib.mRibClearData();
      storeBank.mBankClearData();
      storeAccountEntry.mAccountEntryClearData();
      storeWizardItem.mWizardItemClearData();
      storeSubscription.mSubscriptionClearData();
      storeSubscriptionType.mSubscriptionTypeClearData();
      storeMetaAttrib.mMetaAttribClearData();
    }
  }
});
export default store;
      export const storeSession = getModule(iStoreSession, store);
      export const storeAccidentTravail = getModule(iStoreAccidentTravail, store);
      export const storeActivite = getModule(iStoreActivite, store);
      export const storeActualite = getModule(iStoreActualite, store);
      export const storeApprenti = getModule(iStoreApprenti, store);
      export const storeAttestation = getModule(iStoreAttestation, store);
      export const storeAttestationDef = getModule(iStoreAttestationDef, store);
      export const storeAuthorizedCredit = getModule(iStoreAuthorizedCredit, store);
      export const storeContrat = getModule(iStoreContrat, store);
      export const storeContratTemplate = getModule(iStoreContratTemplate, store);
      export const storeCreneau = getModule(iStoreCreneau, store);
      export const storeEtablissement = getModule(iStoreEtablissement, store);
      export const storeFractionDsn = getModule(iStoreFractionDsn, store);
      export const storeLieu = getModule(iStoreLieu, store);
      export const storeManualBillingDocument = getModule(iStoreManualBillingDocument, store);
      export const storeNumeroObjet = getModule(iStoreNumeroObjet, store);
      export const storeObjetMetier = getModule(iStoreObjetMetier, store);
      export const storePaie = getModule(iStorePaie, store);
      export const storePlageCreneau = getModule(iStorePlageCreneau, store);
      export const storeProjet = getModule(iStoreProjet, store);
      export const storeRubrique = getModule(iStoreRubrique, store);
      export const storeSalarie = getModule(iStoreSalarie, store);
      export const storeSupport = getModule(iStoreSupport, store);
      export const storeAdresse = getModule(iStoreAdresse, store);
      export const storeCivilite = getModule(iStoreCivilite, store);
      export const storeClient = getModule(iStoreClient, store);
      export const storeContact = getModule(iStoreContact, store);
      export const storeMail = getModule(iStoreMail, store);
      export const storeNumero = getModule(iStoreNumero, store);
      export const storeQualite = getModule(iStoreQualite, store);
      export const storeUser = getModule(iStoreUser, store);
      export const storeNotif = getModule(iStoreNotif, store);
      export const storeChat = getModule(iStoreChat, store);
      export const storeDocument = getModule(iStoreDocument, store);
      export const storeDocumentType = getModule(iStoreDocumentType, store);
      export const storeBill = getModule(iStoreBill, store);
      export const storeDelivery = getModule(iStoreDelivery, store);
      export const storeTransaction = getModule(iStoreTransaction, store);
      export const storePaymentMeans = getModule(iStorePaymentMeans, store);
      export const storeRib = getModule(iStoreRib, store);
      export const storeBank = getModule(iStoreBank, store);
      export const storeAccountEntry = getModule(iStoreAccountEntry, store);
      export const storeWizardItem = getModule(iStoreWizardItem, store);
      export const storeSubscription = getModule(iStoreSubscription, store);
      export const storeSubscriptionType = getModule(iStoreSubscriptionType, store);
      export const storeMetaAttrib = getModule(iStoreMetaAttrib, store);
